module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 14
// module chunks = 0